import { render, staticRenderFns } from "./eliminar_pedido.vue?vue&type=template&id=a1efce20"
import script from "./eliminar_pedido.vue?vue&type=script&lang=js"
export * from "./eliminar_pedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports